<template>
  <div class="pcoded-inner-content">
    <div class="main-body">
      <div>
        <div>
          <div>
            <div>
              <div>
                <div
                  class="card"
                  v-for="(message, index) in messages"
                  :key="index"
                >
                  <div class="card-type">
                    <label>Tipo</label>
                    <select v-model="message.type" class="form-control">
                      <option
                        v-for="(type, index) in messageTypes"
                        :key="index"
                        :value="type.name"
                      >
                        {{ type.description }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="
                      message.type === 'imagem' || message.type === 'arquivo'
                    "
                    id="url"
                    class="form-group"
                  >
                    <label>Arquivo</label>
                    <input
                      type="file"
                      @change="handleFiles($event, index)"
                      class="form-control"
                    />
                  </div>

                  <div
                    v-if="
                      message.type !== 'boleto' &&
                        message.type !== 'arquivo' &&
                        message.type !== 'template'
                    "
                    class="form-group "
                  >
                    <label>Mensagem</label>
                    <div>
                      <textarea
                        v-model="message.text"
                        rows="5"
                        cols="5"
                        class="form-control"
                        placeholder="Escreva sua mensagem aqui..."
                      />
                      <p>
                        Para utilizar Emojis, copie
                        <a
                          class="text-c-blue"
                          href="https://www.emojicopy.com/"
                          target="_blank"
                        >
                          neste site
                        </a>
                      </p>
                    </div>
                  </div>

                  <div class="btn-group">
                    <button
                      :class="[
                        'btn btn-danger btn-sm',
                        messages.length === 1 ? 'disabled' : '',
                      ]"
                      :disabled="messages.length === 1"
                      @click="removeFlowWise(index)"
                    >
                      Remover
                    </button>
                  </div>
                </div>
                <div class="addFlowWise">
                  <button
                    :class="[
                      'btn btn-info',
                      messages.length >= 4 ? 'disabled' : '',
                    ]"
                    :disabled="messages.length >= 4"
                    @click="addFlowWise"
                  >
                    ADICIONAR NOVO FLUXO
                  </button>
                </div>
              </div>
            </div>
            <div class="saveFlowWise">
              <!-- <button :class="['btn btn-danger']" @click="resetMessageWise">
                Limpar
              </button> -->
              <button :class="['btn btn-success']" @click="saveMessageWise">
                Salvar Mensagem
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      messageTypes: [
        {
          name: 'texto',
          description: 'Somente Texto',
        },
        {
          name: 'imagem',
          description: 'Imagem + Texto',
        },
        {
          name: 'arquivo',
          description: 'Arquivo',
        },
        {
          name: 'boleto',
          description: 'Boleto',
        },
      ],
      messages: [{ type: 'texto', text: '', file: null }],
    };
  },

  computed: {
    shouldShowFileInput(type) {
      return type === 'imagem' || type === 'arquivo';
    },
    shouldShowMessageInput(type) {
      return !['arquivo', 'template', 'boleto'].includes(type);
    },
  },
  methods: {
    handleFiles(event, index) {
      const file = event.target.files[0];

      if (file) {
        this.$set(this.messages, index, {
          ...this.messages[index],
          file: file,
        });
      }
    },

    addFlowWise() {
      this.messages.push({ type: 'texto', text: '', file: null });
    },
    removeFlowWise(index) {
      this.messages.splice(index, 1);
    },
    saveMessageWise() {
      this.$emit('updateMessage', this.messages);
    },
    resetMessageWise() {
      this.$emit('resetFormData');
    },
  },
};
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-type {
  padding: 15px 0;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.addFlowWise {
  display: flex;
  justify-content: center;
}
.saveFlowWise {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}

.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}
</style>
